import React, { useContext } from "react";
import { Link } from "react-router-dom";
import Accordion from "../Accordion/";
import { LanguageContext } from "../../context/LanguageContext";
import no from "../../context/no";
import en from "../../context/en";

function FAQSection() {
  const { language } = useContext(LanguageContext);
  const translations = language === "no" ? no : en;
  const currentFaqs = translations.FAQ.faqs;

  return (
    <section className="pt-12 pb-16 md:pt-16 md:pb-24">
      <div className="container">
        <div className="wrap">
          <div className="mx-auto max-w-4xl">
            <div className="mb-8 flex flex-col items-center gap-4 text-center md:mb-10">
              <div className="flex items-center w-fit">
                <div className="vertical-line gradient-vertical"></div>
                <h1 className="text-main-dark text-2xl md:text-[2.5rem] font-extrabold">
                  {translations.FAQ.title}
                </h1>
              </div>
              <p className="font-copy text-lg text-main-dark/80 md:text-xl">
                {translations.FAQ.title2}
              </p>
            </div>

            <Accordion faqs={currentFaqs} />

            <div className="mt-8 flex justify-center md:mt-10">
              <Link className="cta cta-dark w-fit" to="/faq">
                {translations.home.button.seeMoreQuestions}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default FAQSection;
